module.exports = __webpack_public_path__ + "static/media/velma-icon.7167c11d.png";